import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import SetupWarehouse from '../../../../components/modules/master/setup-warehouse';
import SetupWarehouseMiddleware from '../../../../middleware/modules/master/setup-warehouse';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares


const mapStateToProps = ({ auth,setupWarehouse }) => ({
  isProcessing: setupWarehouse.isProcessing,
  isError: setupWarehouse.isError,
  errorMessage: setupWarehouse.errorMessage,
  datalist:setupWarehouse.data,
  showModal:setupWarehouse.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>SetupWarehouseMiddleware.create(),
    reset: () =>SetupWarehouseMiddleware.resetList(),
    getHelper: () =>SetupWarehouseMiddleware.getHelper(),
    search: data =>SetupWarehouseMiddleware.list(data),
    update: data =>SetupWarehouseMiddleware.update(data),
    delete: (id,search) =>SetupWarehouseMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class SetupWarehouseContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
   this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.update(id)
    this.props.getHelper()
  }
  createItem(){
    this.props.create()
    this.props.getHelper()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Setup Warehouse List")}
          </title>
        </Helmet>
      <SetupWarehouse
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetupWarehouseContainer);
